/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Progress_StartingInputs */



/**
* | output |
* | --- |
* | "Starting embed export..." |
*
* @param {Audio_Embed_Export_Progress_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_progress_starting = /** @type {((inputs?: Audio_Embed_Export_Progress_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Progress_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l'exportation intégrée...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungs-Export wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'esportazione dell'incorporamento...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта встраивания...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando la exportación de incrustaciones...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始嵌入导出...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込みエクスポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड निर्यात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação de conteúdo incorporado...")
	return /** @type {LocalizedString} */ ("Starting embed export...")
});